<template>
  <div class="teaser-warning container my-size-4 rounded-lg p-3 font-bold">
    <div class="flex items-center">
      <SpriteSymbol name="info" class="mr-size-8 size-4" />
      <span>{{
        $texts(
          'UnpublishedNodeWarning',
          'The linked node in this teaser is unpublished!',
        )
      }}</span>
    </div>
  </div>
</template>

<style lang="postcss">
.teaser-warning {
  background-color: rgb(var(--bk-theme-yellow-normal));
  color: rgb(var(--bk-theme-yellow-dark));
}
</style>
